import register from 'ShopUiBundle/modules/app/registry';

import './style.scss';

// tslint:disable-next-line
register('button-dropdown', () => import(/* webpackMode: "lazy" */'./button-dropdown'));
